import React, { useEffect, useState } from 'react'
import { Card, Col, Container, Row, Table } from 'reactstrap'
import { forkJoin } from 'rxjs';
import * as Yup from "yup";
import CommonService from 'services/CommonService';
import { useFormik } from 'formik';
import { useNavigate, useParams } from 'react-router-dom';
import { Toaster_ENUM } from 'components/constants/dsmConstants';
import { IUserRoleScreenModel } from 'models/IUserRole.Model';
import { RoleModel } from 'models/IRole.Model';
import CustomLoader from 'components/Common/CustomLoader';
import { CustomButton } from 'components/shared/CustomButton';
import { CustomToaster } from 'components/shared/CustomToaster';
import { CustomCheckBox } from 'components/shared/CustomCheckBox';

function UserRoleScreenActivity() {

    const { id } = useParams();
    let navigate = useNavigate();

    const [appScreens, setAppScreens] = useState<Array<IUserRoleScreenModel>>([]);
    const [toast, SetToast] = useState(false);
    const [reqScreenActivityData, setReqScreenActivityData] = useState<Array<IUserRoleScreenModel>>([]);
    const [getRole, setRole] = useState<Array<any>>([]);
    const [roleId, setRoleId] = useState<number>(0);
    const [showLoading, setShowLoading] = useState(true);

    useEffect(() => {
        setRoleId(parseInt(id ?? '0', 10));
        GetUserRoleList();
        GetUserScreenActivityList();
    }, [id]);


    const GetUserScreenActivityList = () => {
        setShowLoading(true)
        CommonService.getWithSingleEntity("userRoleScreenActivity", "Edit", id).then(res => {
            if (res.status == 200) {
                const responseData: Array<IUserRoleScreenModel> = res.data;
                setAppScreens(responseData);
                setReqScreenActivityData(responseData);
                setShowLoading(false)
            }
        }).catch(e => console.log(e));
    }

    const GetUserRoleList = () => {
        setShowLoading(true)
        CommonService.postWithOutData('userRoleScreenActivity', 'GetUserRoleList').then(res => {
            if (res.status == 200) {
                let data: Array<RoleModel> = res.data
                setRole(data);
                setShowLoading(false)
            }
        });
    }

    const bindDefault = (data: Array<IUserRoleScreenModel>) => {
        if (data.length > 0) {
            data.forEach((item, pi) => {
                item.UserScreenActivity.forEach((res, i) => {
                    // if (res.HasAccess) {
                    handleChecked(res.id, res.ScreenActivityMasterId, res.ScreenMasterId, "init", pi, i, res.HasAccess);
                    // }
                });
            });
        }
    }

    const CustomScreenCheckBoxer = (Id: number, Name: string, arr: any[], pI: number) => {

        return (
            <tr style={{ background: '#F3F3F7' }}>
                <td className='px-2 fw-semibold font-size-12' >{Name}</td>
                {arr.map((val, i) => (
                    <td key={i}>
                        <CustomCheckBox
                            label={''}
                            id={val.id}
                            value={val.ActivityName == "Dashboard" ? (val.IsSelected ? false : true) : true}
                            error={undefined}
                            onChange={(e) => handleChecked(Id, val.ScreenActivityMasterId, val.ScreenMasterId, e.target.checked, pI, i, e.target.checked)}
                            defaultChecked={val.ActivityName == "Dashboard" ? (val.IsSelected == true) : true}
                            disabled={val.ActivityName != "Dashboard"}
                        />
                    </td>
                ))}
            </tr>
        )
    }

    const handleChecked = (id, screenActivityMasterId, screenMasterId, type, pi, i, val) => {
        const updatedData = reqScreenActivityData.map(item => {
            if (item.Id === id) {
                const updatedItem = {
                    ...item,
                    ScreenActivity: item.ScreenActivity ? item.ScreenActivity.map(activity => ({
                        ...activity,
                        HasAccess: val,
                        IsSelected: val
                    })) : [],
                    UserScreenActivity: item.UserScreenActivity.map(activity => {
                        if (activity.ScreenActivityMasterId === screenActivityMasterId) {
                            return { ...activity, HasAccess: val, IsSelected: val };
                        }
                        return activity;
                    }),
                };
                return updatedItem;
            }
            return item;
        });
        setReqScreenActivityData(updatedData);
    };

    const updateScreenMaster = () => {
        CommonService.post('userRoleScreenActivity', 'Edit', reqScreenActivityData).then((res) => {
            if (res.status === 200) {
                SetToast(true);
                GetUserScreenActivityList();
            }
        }).catch(e => console.log(e));
    }

    const handleCancel = () => {
        navigate("/screen-accessibility");
    };

    const groupedScreens = {};
    appScreens.forEach(screen => {
        if (!groupedScreens[screen.ScreenTypeId]) {
            groupedScreens[screen.ScreenTypeId] = [];
        }
        groupedScreens[screen.ScreenTypeId].push(screen);
    });

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <CustomLoader isOpen={showLoading} />
                    <Col md={12} sm={4} >
                        <div>
                            <h5 className="d-flex mb-3 fw-semibold text-dofy dofy-admin-font-md" style={{ whiteSpace: "nowrap" }}>{getRole && getRole.find(x => x.Id == id)?.Name} Screen Mapping</h5>
                        </div>
                    </Col>
                    <Card style={{ padding: "20px" }}>
                        <div className=''>
                            {/* <span className={`badge rounded-pill badge-soft-info font-size-8 fw-bolder px-3 pt-2`}>
                            <h5 style={{ color: "#17284b" }}>{getRole && getRole.find(x => x.Id == id)?.Name} Screen Mapping</h5>
                        </span> */}
                            <div className="table-responsive">
                                {Object.keys(groupedScreens).map((screenTypeId, index) => (
                                    <React.Fragment key={screenTypeId}>
                                        <Col lg={12}>
                                            <Table className=' my-3 table-nowrap align-middle table-borderless'>
                                                <tr className='text-dofy py-4 text-center' style={{ background: "#F8F8F8" }}>
                                                    <th className='py-2' style={{ width: '250px' }}>{groupedScreens[screenTypeId][0].ScreenTypeName}</th>
                                                    <th>Dashboard</th>
                                                    <th>Create</th>
                                                    <th>Edit</th>
                                                    <th>View</th>
                                                    <th>Delete</th>
                                                </tr>
                                                {groupedScreens[screenTypeId].map((val, i) => (
                                                    <React.Fragment key={i}>
                                                        {CustomScreenCheckBoxer(val.Id, val.Name, val.UserScreenActivity, i)}
                                                    </React.Fragment>
                                                ))}
                                            </Table>
                                        </Col>
                                        {index < Object.keys(groupedScreens).length - 1 && (
                                            <div style={{ borderTop: "1px solid #ccc", margin: "20px 0" }}></div>
                                        )}
                                    </React.Fragment>
                                ))}
                            </div>
                            <Col style={{ textAlign: "right" }} lg={12}>
                                <CustomButton
                                    type="button"
                                    btnClassName="ms-2 btn-soft-secondary w-md"
                                    iconClasssName="mdi mdi-close"
                                    name=""
                                    onClick={handleCancel}
                                />
                                <CustomButton
                                    type={"submit"}
                                    btnClassName={"ms-2 btn-success"}
                                    iconClasssName=""
                                    name={"Update Screens"}
                                    onClick={() => updateScreenMaster()}
                                />
                            </Col>

                        </div>
                    </Card>
                    <CustomToaster
                        message={Toaster_ENUM.save.text}
                        color={"text-success"}
                        toast={toast}
                        setToast={SetToast}
                        path={'/screen-accessibility'}
                    />
                </Container>
            </div>
        </React.Fragment>
    )
}

export default UserRoleScreenActivity

